import { configureProjectile } from './projectile.js';

export function spawnPlayerProjectile(game, x, z, dx, dz, opts = {}) {
  const p = game.projectiles.acquire();
  configureProjectile(p, {
    team: 0,
    x,
    z,
    dx,
    dz,
    speed: opts.speed ?? 28,
    damage: (opts.damage ?? 1) * (opts.critMul ?? 1),
    life: opts.life ?? 0.9,
    critMul: opts.critMul ?? 1,
    maxBounces: opts.maxBounces ?? (opts.ricochet ? 1 : 0),
    echo: opts.echo,
    sourceWeaponId: opts.sourceWeaponId,
    explosionRadius: opts.explosionRadius ?? 0,
    explosionDamage: opts.explosionDamage ?? 0,
    clusterCount: opts.clusterCount ?? 0,
    delayedFuse: opts.delayedFuse ?? 0,
    bleedDps: opts.bleedDps ?? 0,
    bleedDuration: opts.bleedDuration ?? 0,
  });
}

export function spawnEnemyProjectile(game, x, z, dx, dz, opts = {}) {
  const hasSummoningBoss = !!game?.enemies?.some((e) => (
    e?.isBoss
    && (
      e?._isSummoningHidden
      || (Number.isFinite(e?._pendingSummonDrops) && e._pendingSummonDrops > 0)
      || (Array.isArray(e?._activeSummonAdds) && e._activeSummonAdds.length > 0)
    )
  ));
  // Hard stop for final-boss summon phase: no boss projectile can be created.
  // This guarantees suppression even if some code path still attempts to fire.
  if (opts.boss && (game?._bossPhase2SummonLock || hasSummoningBoss)) return;
  if (opts.sfx !== false) {
    game.audio.play(opts.boss ? 'bossShot' : 'enemyShot', { pitchJitter: 0.03 });
  }
  const p = game.projectiles.acquire();
  configureProjectile(p, {
    team: 1,
    x,
    z,
    dx,
    dz,
    speed: opts.speed ?? 14,
    damage: opts.damage ?? 1,
    life: opts.life ?? 1.4,
    isBossShot: !!opts.boss,
  });
}

// Illumination factor for emissive / basic-material visuals (vision cones,
// projectiles). Returns 1.0 inside the player's light radius and 0.2 well
// outside, with a short smooth falloff at the edge.
export function illuminationAt(game, x, z) {
  const player = game.player;
  if (!player) return 1;
  const r = player.lightRadius ?? 2.0;
  const dx = x - player.x;
  const dz = z - player.z;
  const d = Math.hypot(dx, dz);
  const inner = r * 0.85;
  const outer = r * 1.15;
  if (d <= inner) return 1;
  if (d >= outer) return 0.2;
  const t = (d - inner) / (outer - inner);
  return 1 - t * 0.8;
}


